/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState } from 'react';
import {
  BarChart, Bar, YAxis, CartesianGrid, Tooltip, Legend,
  XAxis,
  Cell,
} from 'recharts';
import { GraphVesselReport } from '../types';
import { Empty } from '../../ScreenAddSmc/Utils/TypeSmc';
import { addRandomColorToData, getBarSize } from '../helper';

function ComponentBarChart({ graphData, primaryColor }: GraphVesselReport) {
  const [graphDataChunks, setGraphDataChunks] = useState<Array<Empty[]>>([]);
  // const [graphDefectDataChunks, setGraphDefectDataChunks] = useState<DefectComparison[]>([]);

  const splitDataIntoChunks = (data: Empty[], chunkSize: number) => {
    const chunks = [];
    for (let i = 0; i < data.length; i += chunkSize) {
      chunks.push(data.slice(i, i + chunkSize));
    }
    return chunks;
  };

  useEffect(() => {
    const updatedData = addRandomColorToData(graphData?.DefectComparison)?.map((item) => ({
      ...item,
      Key: `${item?.Code}`,
    }));
    // setGraphDefectDataChunks(updatedData);

    // Split the updated data into chunks of 16
    const chunks = splitDataIntoChunks(updatedData as Empty[], 7);
    setGraphDataChunks(chunks);
  }, [graphData]);

  const getTicks = (chunkData: Empty[]) => {
    const maxValue = Math.max(...chunkData.map((d) => Math.max(d.RevisedDefectCount ?? 0, d.DefectCount ?? 0)));
    const ticks = Array.from({ length: maxValue + 1 }, (_, i) => i);
    return maxValue > 5 ? ticks : [1, 2, 3, 4, 5, 6, 7, 8];
  };

  // function customLabelList() {
  //   if (!graphDefectDataChunks || !Array.isArray(graphDefectDataChunks)) {
  //     return null;
  //   }

  //   // Helper function to chunk the array into smaller arrays of size 10
  //   const chunkArray = (array: DefectComparison[], chunkSize: number): DefectComparison[][] => {
  //     const result: DefectComparison[][] = [];
  //     for (let i = 0; i < array.length; i += chunkSize) {
  //       result.push(array.slice(i, i + chunkSize));
  //     }
  //     return result;
  //   };

  //   const chunks = chunkArray(graphDefectDataChunks, 5);
  //   const rows = [];
  //   for (let i = 0; i < chunks.length; i += 3) {
  //     rows.push(chunks.slice(i, i + 3));
  //   }
  //   // eslint-disable-next-line prefer-const
  //   // let num = 1;
  //   return (
  //     <div style={{ marginBottom: '10px' }}>
  //       {rows.map((row, rowIndex) => (
  //         <div
  //           key={`row-${rowIndex}`}
  //           style={{
  //             display: 'flex', gap: '25px', marginBottom: '10px', width: '100%',
  //           }}
  //         >
  //           {row.map((chunk, chunkIndex) => (
  //             <div
  //               key={`chunk-${rowIndex}-${chunkIndex}`}
  //               style={{
  //                 width: '220px',
  //               }}
  //             >
  //               {/* {chunk.map((data, index) => {
  //                 const label = `${data.Code} = ${data.DefectName}`;
  //                 // num += 1;
  //                 return (
  //                   <div key={`label-${rowIndex}-${chunkIndex}-${index}`} style={{ marginBottom: '6px', fontSize: '13px' }}>
  //                     {label}
  //                   </div>
  //                 );
  //               })} */}
  //               {chunk.map((data, index) => (
  //                 <div
  //                   key={`label-${rowIndex}-${chunkIndex}-${index}`}
  //                   style={{
  //                     display: 'flex', alignItems: 'center', marginBottom: '6px', fontSize: '13px',
  //                   }}
  //                 >
  //                   <div
  //                     style={{
  //                       width: '10px',
  //                       height: '10px',
  //                       backgroundColor: data.colorHex,
  //                       marginRight: '8px',
  //                       borderRadius: '2px',
  //                     }}
  //                   />
  //                   <span>
  //                     {data.DefectName}
  //                   </span>
  //                 </div>
  //               ))}
  //             </div>
  //           ))}
  //         </div>
  //       ))}
  //     </div>
  //   );
  // }

  return (
  // <>
  //   <svg width={0} height={0}>
  //     <defs>
  //       {graphDataChunks.map((chunk, chunkIndex) => chunk.map((entry, index) => (
  //         <pattern
  //           key={`pattern-${chunkIndex}-${index}`}
  //           id={`squarePattern-${chunkIndex}-${index}`}
  //           patternUnits="userSpaceOnUse"
  //           width={10}
  //           height={10}
  //         >
  //           <rect width={10} height={10} fill={entry.colorHex} />
  //           <rect x={1.5} y={1.5} width={12} height={12} fill="#FFFFFF" />
  //         </pattern>
  //       )))}
  //     </defs>
  //   </svg>

  //   {graphDataChunks.map((chunk, chunkIndex) => (
  //     <div
  //       key={`chart-${chunkIndex}`}
  //       className="barChartContainer"
  //       style={{
  //         borderColor: primaryColor,
  //         marginTop: '20px', // Space between charts
  //         marginBottom: '20px', // Space between charts
  //       }}
  //     >
  //       <BarChart
  //         width={700}
  //         height={520}
  //         data={chunk}
  //       >
  //         <CartesianGrid />
  //         <XAxis
  //           dataKey="Key"
  //         />
  //         <YAxis />
  //         <Tooltip />
  //         <Legend />
  //         <defs>
  //           {chunk.map((entry, index) => (
  //             <linearGradient id={`gradient-${index}`} x1="0" y1="0" x2="0" y2="1" key={`gradient-${index}`}>
  //               <stop offset="0%" stopColor={entry.colorHex} stopOpacity={1} />
  //               <stop offset="100%" stopColor="#f3f3f3" stopOpacity={1} />
  //             </linearGradient>
  //           ))}
  //         </defs>

  //         <Bar dataKey="DefectCount" barSize={getBarSize(chunk.length)}>
  //           {chunk.map((entry, index) => (
  //             <Cell
  //               stroke="#000" // Border color
  //               strokeWidth={1} // Border thickness
  //               key={`cell-${index}`}
  //               fill={`url(#gradient-${index})`}
  //             />
  //           ))}
  //         </Bar>
  //         {chunk.length > 0
  //         && (
  //         <Bar dataKey="RevisedDefectCount" barSize={getBarSize(chunk.length)}>
  //           {chunk.map((entry, index) => (
  //             <Cell
  //               // stroke="#000" // Border color
  //               // strokeWidth={1} // Border thickness
  //               key={`cell-pattern-${index}`}
  //               fill={`url(#squarePattern-${chunkIndex}-${index})`}
  //             />
  //           ))}
  //         </Bar>
  //         )}

  //       </BarChart>
  //     </div>
  //   ))}
  //   <div style={{
  //     width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto',
  //   }}
  //   >
  //     {customLabelList()}
  //   </div>
  // </>
    <>
      <svg width={0} height={0}>
        <defs>
          {graphDataChunks?.map((chunk, chunkIndex) => chunk?.map((entry, index) => (
            <pattern
              key={`pattern-${chunkIndex}-${index}`}
              id={`squarePattern-${chunkIndex}-${index}`}
              patternUnits="userSpaceOnUse"
              width={10}
              height={10}
            >
              <rect width={10} height={10} fill={entry?.colorHex} />
              <rect x={1.5} y={1.5} width={12} height={12} fill="#FFFFFF" />
            </pattern>
          )))}
        </defs>
      </svg>
      <svg width={0} height={0}>
        <defs>
          <pattern
            id="squarePattern-small-box"
            patternUnits="userSpaceOnUse"
            width={6}
            height={6}
          >
            <rect width={6} height={6} fill="#a5a2a2ff" />
            <rect x={1} y={1} width={4} height={4} fill="#FFFFFF" />
          </pattern>
        </defs>
      </svg>

      {graphDataChunks.map((chunk, chunkIndex) => (
        <>
          {chunkIndex > 0 && chunk?.length > 1 && (
          <div className="pageHeader">
            <div className="topHeader">
              <div className="pt30 pb10">
                {graphData?.VesselName}
                {' '}
                Defects - Page
                {' '}
                {chunkIndex + 1}
              </div>
            </div>
          </div>
          )}
          <div
            key={`chart-container-${chunkIndex}`}
            style={{
              borderColor: primaryColor,
              marginTop: '20px',
              marginBottom: '20px',
              borderWidth: '4px',
              borderStyle: 'solid',
              borderRadius: '8px',
            }}
          >
            <div
              style={{
                borderColor: primaryColor,
                marginTop: '20px',
                marginBottom: '20px',
                padding: '15px',
              }}
            >
              <BarChart
                width={700}
                height={380}
                data={chunk}
              >
                <CartesianGrid />
                <XAxis dataKey="Key" hide />
                <YAxis
                  allowDecimals={false}
                  ticks={getTicks(chunk)}
                  label={{
                    value: 'Number of Defects',
                    angle: -90,
                    position: 'insideLeft',
                    style: { textAnchor: 'middle' },
                  }}
                />
                <Tooltip />
                <Legend />
                <defs>
                  {chunk?.map((entry, index) => (
                    <linearGradient id={`gradient-${index}`} x1="0" y1="0" x2="0" y2="1" key={`gradient-${index}`}>
                      <stop offset="0%" stopColor={entry?.colorHex} stopOpacity={1} />
                      <stop offset="100%" stopColor="#f3f3f3" stopOpacity={1} />
                    </linearGradient>
                  ))}
                </defs>

                <Bar dataKey="RevisedDefectCount" barSize={getBarSize(chunk?.length)}>
                  {chunk?.map((entry, index) => (
                    <Cell
                      stroke="#000"
                      strokeWidth={1}
                      key={`cell-${index}`}
                      fill={`url(#gradient-${index})`}
                    />
                  ))}
                </Bar>
                {chunk?.length > 0 && (
                <Bar dataKey="DefectCount" barSize={getBarSize(chunk?.length)}>
                  {chunk.map((entry, index) => (
                    <Cell
                      stroke="#000"
                      strokeWidth={1}
                      key={`cell-pattern-${index}`}
                      fill={`url(#squarePattern-${chunkIndex}-${index})`}
                    />
                  ))}
                </Bar>
                )}
              </BarChart>
            </div>

            {/* Custom labels for this chart */}
            <div
              style={{
                padding: '10px',
                display: 'flex',
                justifyContent: 'center',
                marginTop: '-15px',
                marginBottom: '10px',
              }}
            >
              <div
                style={{
                  padding: '10px',
                  display: 'grid',
                  gridTemplateColumns: 'repeat(2, 1fr)',
                  gridColumnGap: '20px',
                  border: '1px solid #ccc',
                }}
              >
                {chunk?.map((data, index) => (
                  <div
                    key={`label-${chunkIndex}-${index}`}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginBottom: '5px',
                      fontSize: '13px',
                    }}
                  >
                    <div
                      style={{
                        width: '12px',
                        height: '12px',
                        backgroundColor: data?.colorHex,
                        marginRight: '8px',
                        borderRadius: '2px',
                      }}
                    />
                    <span>{data?.DefectName}</span>
                  </div>
                ))}
                {chunk?.some((data) => data?.DefectCount > 0) && (
                  <div
                    key={`label-${chunkIndex}`}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginBottom: '5px',
                      fontSize: '13px',
                    }}
                  >
                    <svg width="12" height="12" style={{ marginRight: '8px', borderRadius: '2px', border: '1px solid #a5a2a2ff' }}>
                      <rect width="12" height="12" fill="url(#squarePattern-small-box)" />
                    </svg>
                    <span>{graphData?.LastjobDate || 'Previous Defects'}</span>
                  </div>
                )}
              </div>
            </div>
          </div>
          {chunkIndex < graphDataChunks.length - 1 && <div className="page-break" />}
        </>
      ))}
    </>
  );
}

export default ComponentBarChart;
